import { render } from "./SessionsByDevice.vue?vue&type=template&id=37965a53"
import script from "./SessionsByDevice.vue?vue&type=script&lang=js"
export * from "./SessionsByDevice.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__